'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Device = function () {
    function Device() {
        _classCallCheck(this, Device);
    }

    _createClass(Device, null, [{
        key: 'hasWindow',
        value: function hasWindow() {
            return typeof window !== 'undefined';
        }
    }, {
        key: 'createScript',
        value: function createScript(src, async, onload) {
            var script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.onload = onload;
            document.body.appendChild(script);
        }
    }]);

    return Device;
}();

exports.default = Device;


/*****************
 ** WEBPACK FOOTER
 ** ./~/fsts/lib/Device.js
 ** module id = 115
 ** module chunks = 0
 **/